module.exports = __webpack_public_path__ + "img/sidebar.35d40fd0.svg";